import { ChoiceGroup } from '@consta/uikit/ChoiceGroup'
import { CollapseGroup } from '@consta/uikit/CollapseGroup'
import type { Nullable } from 'common/types'
import { useState } from 'react'

import type { ObjectPropertiesChoiceItem } from '../types'
import { EPropertiesChoiceItem } from '../types'
import css from './ProjectObjects.css'

type ItemType = {
  label: string
  content: Nullable<string>
}

const choiceItems: ObjectPropertiesChoiceItem[] = [
  { disabled: false, name: 'Инфо', key: EPropertiesChoiceItem.info },
  {
    disabled: false,
    name: 'Параметры',
    key: EPropertiesChoiceItem.param,
  },
  {
    disabled: false,
    name: 'История',
    key: EPropertiesChoiceItem.history,
  },
]

function getItems(choiceValue: ObjectPropertiesChoiceItem): ItemType[] {
  switch (choiceValue.key) {
    case EPropertiesChoiceItem.param:
      return [
        { label: 'Позиции', content: null },
        { label: 'Стили', content: null },
        { label: 'Инспектор', content: null },
      ]
    case EPropertiesChoiceItem.history:
      return [
        { label: '8 мая 2022', content: 'Мамаев Дмитрий' },
        { label: '2 мая 2022', content: 'Мамаев Дмитрий' },
      ]
    case EPropertiesChoiceItem.info:
      return [
        { label: 'Общее', content: null },
        { label: 'Статистика', content: null },
        { label: 'Комментарий', content: null },
      ]
  }
}

const ProjectObjectProperties = () => {
  const [choiceValue, setChoiceValue] = useState<ObjectPropertiesChoiceItem>(choiceItems[0])
  const items = getItems(choiceValue)

  return (
    <div>
      <ChoiceGroup
        className={css.objectsPropertiesChoiceGroup}
        size="s"
        view="ghost"
        name="objectsProperties__choiceGroup"
        multiple={false}
        items={choiceItems}
        value={choiceValue}
        getItemLabel={item => item.name}
        getItemDisabled={item => item.disabled}
        onChange={setChoiceValue}
      />
      <CollapseGroup
        className={css.treeBarCollapseTab}
        horizontalSpace="s"
        iconPosition="right"
        divider={true}
        items={items}
      />
    </div>
  )
}

export { ProjectObjectProperties }
